var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('button',{staticClass:"\n        uk-button\n        uk-button-primary\n        uk-display-block\n        uk-width-1-1\n    ",class:{active: _vm.isActive},attrs:{"type":"button"},on:{"click":_vm.click}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }